"use client"

import { useAppDispatch } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { TypeCategory } from "@/lib/redux/features/store/type"
import { useParams } from "next/navigation"
import { ReactNode } from "react"

type CategoryProductsContainerProps = {
  children: ReactNode,
  productsResponse?: any,
  category?: TypeCategory,
}

let refSSR: any = {}

const CategoryProductsContainer = ({ children, productsResponse, category }: CategoryProductsContainerProps) => {
  const dispatch = useAppDispatch()
  const params = useParams()

  const key = `${category ? category.id : "current"}_${params.page || 1}`
  if (!refSSR[key]) {
    refSSR = {
      [key]: true
    }
    dispatch(productActions.setCategoryProductsData(productsResponse))
  }

  return children
}

export default CategoryProductsContainer